import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 비상장 스타트업 ")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 정보공유 커뮤니티 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 엔젤리그 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 유니콘이 될 스타트업에 대한 ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 수준 높은 투자 정보를 ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 공유해보세요! ")

import {Plugins} from '@capacitor/core'
import {AgBoxS} from '@/components/ag'
import yourApp from './your-app.pure.svg'
import google from './google.png'
import google2 from './google@2x.png'
import google3 from './google@3x.png'
import ios from './ios.png'
import ios2 from './ios@2x.png'
import ios3 from './ios@3x.png'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const androidUrl = 'https://play.google.com/store/apps/details?id=io.angelleague.angelleague'
const iosUrl = 'https://apps.apple.com/kr/app/%EC%97%94%EC%A0%A4%EB%A6%AC%EA%B7%B8/id1558999691'

const {Browser} = Plugins

const goUrl = (url: string) => {
  Browser.open({url})
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AgBoxS), null, {
    default: _withCtx(() => [
      _createVNode(_unref(AgBoxS), {
        "container-as": "img",
        src: _unref(yourApp),
        alt: "app icon",
        css: {width: 120, height: 120, mb: 32}
      }, null, 8, ["src"]),
      _createVNode(_unref(AgBoxS), { css: {fontWeight: 700, fontSize: 18, lineHeight: '26px', mb: 4} }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), { css: {fontWeight: 700, fontSize: 36, lineHeight: '52px', mb: 32} }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), { css: {fontWeight: 400, fontSize: 18, lineHeight: '26px', mb: 16} }, {
        default: _withCtx(() => [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})